export const REDIRECT_EXTERNAL = 'REDIRECT_EXTERNAL'

export type ActionType = {
  type: typeof REDIRECT_EXTERNAL
  url: string
}

type ExternalRedirectType = (url: string) => ActionType

const externalRedirect: ExternalRedirectType = (url = '') => ({
  type: REDIRECT_EXTERNAL,
  url
})

export default externalRedirect
